import { IMenuItem } from '../../interfaces/sidebar';
import { EUserProfileIds } from '../../interfaces/user';

export const MENUS_COMMON_LOGGED: IMenuItem[] = [
	{ label: 'Home', icon: 'fa-solid fa-home', route: '/' },
];

export const MENUS_VISITOR = (actions: any): IMenuItem[] => [
	{ label: 'Home', icon: 'fa-solid fa-home', route: '/' },
];

export const MENUS_BY_ROLE = (
	actions: any
): Record<EUserProfileIds, IMenuItem[]> => ({
	[EUserProfileIds.PORTAL_MANAGER]: [
		{
			label: 'Versões',
			icon: 'fa-solid fa-code-compare',
			route: 'preferences/records/versions',
		},
	],

	[EUserProfileIds.APPLICATION_ADMIN]: [
		{
			label: 'Dashboard',
			icon: 'fa-solid fa-chart-column',
			route: '/dashboard',
			feature: 'dashboard',
		},
		{
			label: 'Portal B2B',
			icon: 'fa-solid fa-gears',
			route: '/preferences/b2b-portal',
			module: 'selling',
		},
		{
			label: 'Força de Vendas',
			icon: 'fa-solid fa-mobile',
			route: '/preferences/sales-force',
			module: 'afv',
		},
		{
			label: 'Área do Cliente',
			icon: 'fa-solid fa-file-invoice-dollar',
			route: '/preferences/client-area',
			module: 'backoffice',
		},
		{
			label: 'Cadastros',
			icon: 'fa-solid fa-folder',
			route: '/preferences/records',
		},
		{
			label: 'Pedidos',
			icon: 'fa-solid fa-bag-shopping',
			route: '/dashboard/orders',
		},
		{
			label: 'Relatórios',
			icon: 'fa-solid fa-file-contract',
			route: '/preferences/reports',
		},
		{
			label: 'Agenda e Rotas',
			icon: 'fa-solid fa-calendar',
			route: '/preferences/schedule-and-routes',
			feature: 'userSchedules',
		},
		{
			label: 'Outros',
			icon: 'fa-solid fa-ellipsis',
			action: actions.openSettingsMenu,
		},
	],

	[EUserProfileIds.CUSTOMER]: [
		{
			label: 'Pedidos',
			icon: 'fa-solid fa-bag-shopping',
			route: '/account/orders',
		},
		{
			label: 'Financeiro',
			icon: 'fa-solid fa-wallet',
			route: '/client-area/accounts-receivable',
			module: 'backoffice',
		},
		{
			label: 'Notas Fiscais',
			icon: 'fa-solid fa-file-invoice-dollar',
			route: '/client-area/invoices',
			module: 'backoffice',
		},

		{
			label: 'Documentos',
			icon: 'fa-solid fa-file',
			route: '/client-area/categories',
			module: 'backoffice',
		},
	],

	[EUserProfileIds.CUSTOMER_ADMIN]: [
		{
			label: 'Pedidos',
			icon: 'fa-solid fa-bag-shopping',
			route: '/account/orders',
		},
		{
			label: 'Financeiro',
			icon: 'fa-solid fa-wallet',
			route: '/client-area/accounts-receivable',
			module: 'backoffice',
		},
		{
			label: 'Notas Fiscais',
			icon: 'fa-solid fa-file-invoice-dollar',
			route: '/client-area/invoices',
			module: 'backoffice',
		},
		{
			label: 'Documentos',
			icon: 'fa-solid fa-file',
			route: '/client-area/categories',
			module: 'backoffice',
		},
		{
			label: 'Cadastros',
			icon: 'fa-solid fa-folder',
			route: '/preferences/records',
		},
	],

	[EUserProfileIds.SELLER]: [
		{
			label: 'Dashboard',
			icon: 'fa-solid fa-chart-column',
			route: '/dashboard',
			feature: 'dashboard',
		},
		{
			label: 'Cadastros',
			icon: 'fa-solid fa-folder',
			route: '/preferences/records',
		},
		{
			label: 'Pedidos',
			icon: 'fa-solid fa-bag-shopping',
			route: '/dashboard/orders',
		},
		{
			label: 'Relatórios',
			icon: 'fa-solid fa-file-contract',
			route: '/preferences/reports',
		},

		{
			label: 'Agenda e Rotas',
			icon: 'fa-solid fa-calendar',
			route: '/preferences/schedule-and-routes',
			feature: 'userSchedules',
		},
		{
			label: 'Suporte e Ajuda',
			icon: 'fa-solid fa-question-circle',
			route: '/preferences/support',
		},
	],

	[EUserProfileIds.INTEGRATOR]: [], // futuro
	[EUserProfileIds.GUEST]: MENUS_VISITOR(actions),
});
